import { makeValidatedRequest } from './requestExecutor/make-validated-request';
import type { IHttpRequestParams, IValidatedResponse } from './types';

export async function deleteRequest<T>({
  path,
  schema,
  options,
}: IHttpRequestParams<T>): Promise<IValidatedResponse<T>> {
  return makeValidatedRequest({
    method: 'DELETE',
    path,
    schema,
    options,
  });
}
